import Component from "./ShortcutToast";
export default Component;
